import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SiteHeaderComponent} from '../site_header/siteHeader.component';
import {SiteFooterComponent} from '../site_footer/siteFooter.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule ,ReactiveFormsModule} from '@angular/forms';
 

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule 

     ],
    declarations: [
        SiteHeaderComponent,
        SiteFooterComponent
    ],
    exports: [
        SiteHeaderComponent,
        SiteFooterComponent
    ]
})
export class SharedModule {}